import { useTranslation } from "react-i18next";
import SectionHeader from "../common/SectionHeader";
import { acfList, acfText } from "../../utils/landingAcf";
import LandingFeatureGrid from "./LandingFeatureGrid";
import LandingSection from "./LandingSection";
import ScrollReveal from "./ScrollReveal";
import SectionLoader from "../common/SectionLoader";
import "./LandingFeatures.css";
import "./LandingSections.css";

function LandingFeatures({ acf, loading = false }) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <LandingSection className="landing-features">
        <SectionLoader size="md" label={t("Loading section")} />
      </LandingSection>
    );
  }

  const title = acfText(acf.why_choose_title);
  const features = acfList(acf, "feature_");

  if (!title && features.length === 0) return null;

  return (
    <LandingSection className="landing-features">
      {title ? (
        <ScrollReveal className="landing-section__intro">
          <SectionHeader
            title={title}
            showAccent
            centered
            titleId="landing-features-title"
            containerClass=""
          />
        </ScrollReveal>
      ) : null}
      {features.length > 0 ? (
        <LandingFeatureGrid features={features} labelledBy={title ? "landing-features-title" : undefined} />
      ) : null}
    </LandingSection>
  );
}

export default LandingFeatures;
